export const iconFontAwesomeReligionSynagogue = (
	<i className="fa-solid fa-synagogue"></i>
);
